import './App.css';
import sunset from './assets/sunset.JPG'; 
import folder from './assets/folder.png';
import { useState, useEffect } from 'react';
import SubmitNoteWindow from "./SubmitNote";
import ArtistLoading from './ArtistLoading';

function App() {
  const [jobsOpened, setOpenJobs] = useState(false);
  const [musicOpened, setMusicOpened] = useState(false);
  const [freelancingOpened, setFreelancingOpened] = useState(false);
  const [emailOpened, setEmailOpened] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile viewport
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Add mousemove event listener for the sparkle effect
    const handleMouseMove = (event) => {
      createSparkle(event.clientX, event.clientY);
    };

    document.addEventListener('mousemove', handleMouseMove);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const createSparkle = (x, y) => {
    // Create a sparkle element
    const sparkle = document.createElement('div');
    
    // Randomly choose which color class to apply
    const randomColor = Math.random() > 0.5 ? 'sparkle-yellow' : 'sparkle-blue'; // 50% chance for each color
    sparkle.classList.add('sparkle', randomColor);

    // Set the sparkle position near the cursor
    sparkle.style.left = `${x - 5}px`; // Adjust for center
    sparkle.style.top = `${y - 5}px`;  // Adjust for center

    // Append sparkle to the body
    document.body.appendChild(sparkle);

    // Remove sparkle after animation ends
    setTimeout(() => {
      sparkle.remove();
    }, 1000); // Same as the duration of the animation
  };

  return (
    <>
    <div className="app-container">
      {/* Retro Browser Container (Terminal) */}
      <div className="retro-browser">
        <div className="window-header">
          <div className="window-buttons">
            <span className="button red"></span>
            <span className="button yellow"></span>
            <span className="button green"></span>
          </div>
          <div className="terminal-title">C:\User\Hannah_Hwong</div>
        </div>
        <img src={sunset} className="retro-image" />
      </div>

      {/* Folder Section */}
      <div className="folder-section">
        {/* Job Folder */}
        <div
          className="folder-item"
          onClick={() => setOpenJobs(!jobsOpened)}
        >
          <img 
            src={folder} 
            width="64px" 
            height="64px" 
            className="folder-button"
          />
          <p className="folder-text">day_job</p>
        </div>
        {jobsOpened && (
          <div className="folder-content">
            <p>remotely working at 1Password as a <b>full stack engineer</b></p>
          </div>
        )}

        {/* Music Folder */}
        <div
          className="folder-item"
          onClick={() => setMusicOpened(!musicOpened)}
        >
          <img 
            src={folder} 
            width="64px" 
            height="64px" 
            className="folder-button" 
          />
          <p className="folder-text">music_and_poetry_projects</p>
        </div>
        {musicOpened && (
          <div className="folder-content">
            <p>
              a music visualization app I recently built:{" "}
              <a
                href="https://hannahhwong.github.io/boogie-nights/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#03dbfc",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                boogie nights
              </a>
            </p>
          </div>
        )}

        {/* Freelancing Folder */}
        <div
          className="folder-item"
          onClick={() => setFreelancingOpened(!freelancingOpened)}
        >
          <img 
            src={folder} 
            width="64px" 
            height="64px" 
            className="folder-button"
          />
          <p className="folder-text">play_therapy_site</p>
        </div>
        {freelancingOpened && (
          <div className="folder-content">
            <p>I build <a href="https://www.playtherapyapps.com/" target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "purple",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}>applications children use during therapy</a></p>
          </div>
        )}
      </div>
    </div>
    
    <div style={{ display: "flex", position: "relative", marginLeft: "60%", marginTop: "40px", gap: "20px" }}>
       

    <a href="https://www.linkedin.com/in/hannah-hwong" target="_blank" rel="noopener noreferrer">
      <i class="fa-brands fa-linkedin linkedin-icon"></i>
    </a>

    </div>
    <SubmitNoteWindow />
    <ArtistLoading />
    </>
  );
}

export default App;
